import { render, staticRenderFns } from "./hocSticky.vue?vue&type=template&id=2735d370&"
import script from "./hocSticky.vue?vue&type=script&lang=js&"
export * from "./hocSticky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports